import React from "react";
import { useSelector } from "react-redux";
import WidgetCarouselCard from "../../features/widget/widgetCarouselCard/WidgetCarouselCard";
import pathRouts from "../../../enums/pathRoute";
import teachingAssistantBotImg from "../../../../assests/assistantBotPage/AssistantBotImg.png";

const BotsCarouselWidget = () => {

    const { texts } = useSelector(state => state.translate);
    
    return (
        <WidgetCarouselCard
            color="#DFDBF9"
            title={texts.botTitle}
            image={teachingAssistantBotImg}
            imageAlt={texts.botTitle}
            link={`/${pathRouts.BOT}`}
        />
    );
};
export default BotsCarouselWidget;